// Simple vs Advanced UI view — a per-browser PRESENTATION preference, not
// security. USER-FACING labels are "Standard mode" (internal: simple) and
// "Advanced mode" (internal: advanced) — the stored values and the `simple`
// flag keep the original names so saved preferences survive. Simple trims the sidebar and in-page builder affordances down to
// the surfaces a non-technical user consumes (apps, agents, tasks, docs);
// every page stays reachable by direct URL so links from chat, alerts and the
// Board keep working. Backed by localStorage like the per-page rail state; a
// custom event fans changes out to every mounted consumer (Layout, Board,
// Workflows, Docs) without a provider.
import { useEffect, useState } from "react";

const KEY = "cortex_ui_view";
const EVENT = "cortex:ui-view";

export function getUiView() {
  try {
    return localStorage.getItem(KEY) === "simple" ? "simple" : "advanced";
  } catch {
    return "advanced";
  }
}

export function setUiView(view) {
  try {
    localStorage.setItem(KEY, view === "simple" ? "simple" : "advanced");
  } catch {
    /* storage unavailable (private mode) — the event still updates this tab */
  }
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function useUiView() {
  const [view, setView] = useState(getUiView);
  useEffect(() => {
    const sync = () => setView(getUiView());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return { view, simple: view === "simple", setUiView };
}
